import { prefixerT } from '.'

export const ROUTE_APROBACION_ORDEN_COMPRA = prefixerT('aprobacion-orden-compra')
export const ROUTE_APROBACION_SOLICITUDES = prefixerT('aprobacion-solicitud')
export const ROUTE_APROBACION_CATEGORIA_SOLICITUDES = prefixerT('aprobacion-solicitud-categoria')
export const ROUTE_CREACION_COTIZACION = prefixerT('crear-cotizacion')
export const ROUTE_CREACION_ORDEN_COMPRA = prefixerT('orden-compra')
export const ROUTE_CREACION_ORDEN_ENTREGA = prefixerT('crear-orden-entrega')
export const ROUTE_CREACION_SOLICITUD = prefixerT('crear-solicitud')
export const ROUTE_GESTION_ORDENES_COMPRA = prefixerT('gestion-ordenes-compra')
export const ROUTE_GESTION_ORDENES_ENTREGA = prefixerT('gestion-ordenes-entrega')
export const ROUTE_GESTION_PUBLICACIONES_SOLICITUD = prefixerT('gestion-publicaciones-solicitud')
export const ROUTE_GESTION_SOLICITUDES = prefixerT('gestion-solicitudes')
export const ROUTE_GESTION_COTIZACIONES = prefixerT('gestion-cotizaciones')
export const ROUTE_SELECCION_COTIZACIONES = prefixerT('seleccion-cotizaciones')
export const ROUTE_RECEPCION_ORDEN_ENTREGA_BIEN = prefixerT('recepcion-orden-entrega-bien')
export const ROUTE_RECEPCION_ORDEN_ENTREGA_SERVICIO = prefixerT('recepcion-orden-entrega-servicio')
export const ROUTE_REVISION_RECEPCION_ORDEN_ENTREGA = prefixerT('revision-recepcion-orden-entrega')
